import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Interactive entry points into the product (cards OK — they are actions).
 */
function PathwaysSection() {
  const pathways = [
    {
      title: 'Co-founder search',
      body: 'Filter by skills, interests, and goals to shortlist people worth talking to.',
      to: '/search',
      cta: 'Start searching',
    },
    {
      title: 'Community feed',
      body: 'Share what you are building, ask for advice, and build trust before you commit.',
      to: '/feed',
      cta: 'Open the feed',
    },
    {
      title: 'Startup jobs',
      body: 'Browse published roles from companies hiring on CofounderHubs.',
      to: '/startup-jobs',
      cta: 'View jobs',
    },
    {
      title: 'Hire on the hub',
      body: 'Post with Basic, Enhanced, or Premium visibility — then manage applications in one flow.',
      to: '/post-job',
      cta: 'Post a role',
    },
  ];

  return (
    <section className="home-pathways" id="start-here">
      <div className="home-section-inner">
        <header className="home-section-head ch-reveal">
          <h2>Start where you need momentum</h2>
          <p>Jump straight into the part of the hub that matches today&apos;s priority.</p>
        </header>
        <div className="home-pathways-grid ch-stagger">
          {pathways.map((item) => (
            <Link key={item.title} to={item.to} className="home-pathway ch-reveal">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
              <span className="home-pathway-cta">{item.cta}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PathwaysSection;
